import React, { useEffect, useState } from "react";
import { Navigate, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../Components/ui/LoadingSpinner";

const AuthProtected = ({
  children,
  allowedRoles,
  requiredPermissions,
  requiredPermissionsforSalon,
}) => {
  const { user, token } = useSelector((state) => state.user);
  const { subscriptionData } = useSelector((state) => state.vendor);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (user !== undefined && token !== undefined) {
      setReady(true);
    }
  }, [user, token]);

  if (!ready) {
    return <LoadingSpinner />;
  }

  if (!token || !user) {
    if (allowedRoles?.includes("admin")) {
      return <Navigate to="/admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles?.includes("customer") && user.role !== "customer") {
    // Only customers can access customer routes
    return <Navigate to="/login" replace />;
  }

  if (
    allowedRoles &&
    !allowedRoles.includes(user.role) &&
    allowedRoles.some((r) => ["salon_owner", "employee"].includes(r))
  ) {
    return <Navigate to="/login" replace />;
  }
  if (allowedRoles?.includes("admin") && user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  if (requiredPermissions) {
    if (!subscriptionData) {
      return <LoadingSpinner />;
    }

    const hasPermission = requiredPermissions(subscriptionData);

    if (!hasPermission) {
      return <Navigate to="/no-permission" replace />;
    }
  }
  // if (requiredPermissionsforSalon) {
  //   if (!subscriptionData) {
  //     return <LoadingSpinner />;
  //   }

  //   const hasPermission = requiredPermissionsforSalon(subscriptionData);

  //   if (!hasPermission) {
  //     return <Navigate to="/subscription-over" replace />;
  //   }
  // }
  if (user.role === "salon_owner" || user.role === "employee") {
    const isExpired =
      (subscriptionData && subscriptionData?.status === "inactive") ||
      subscriptionData?.days_left === 0;

    const allowedExpiredRoutes = [
      "/salon/subscription",
      "/salon/plans",
      "/salon/subscription/success",
    ];

    if (isExpired) {
      const currentPath = window.location.pathname;

      const isAllowed = allowedExpiredRoutes.some((route) =>
        currentPath.startsWith(route),
      );

      if (!isAllowed) {
        return <Navigate to="/subscription-over" replace />;
      }
    }
  }
  return children;
};
const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
